
const digest = '10b838a53510acf9925534aea61b9ad88010bdae1657812761e9e1f6a485a963';
const classes = {"wrapper":"_wrapper_zvw7l_1","date":"_date_zvw7l_12","content":"_content_zvw7l_19","item":"_item_zvw7l_26","title":"_title_zvw7l_32","text":"_text_zvw7l_35","controls":"_controls_zvw7l_38"};
const css = `._wrapper_zvw7l_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_zvw7l_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_zvw7l_1 ._date_zvw7l_12 {
  font-size: 14px;
  color: #000000;
  max-width: 120px;
  padding: 24px 0 24px 24px;
  min-width: 160px;
}
._wrapper_zvw7l_1 ._content_zvw7l_19 {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 24px 0;
}
._wrapper_zvw7l_1 ._content_zvw7l_19 ._item_zvw7l_26 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_zvw7l_1 ._content_zvw7l_19 ._item_zvw7l_26 ._title_zvw7l_32 {
  color: grey;
}
._wrapper_zvw7l_1 ._content_zvw7l_19 ._item_zvw7l_26 ._text_zvw7l_35 {
  color: #000000;
}
._wrapper_zvw7l_1 ._controls_zvw7l_38 {
  min-width: 100px;
  max-width: 100px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  margin: -24px 0;
  gap: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  